import React from "react";
import s from "./ChooseUs.module.css";

const ChooseUs = () => {
  return (
    <div id="chooseUs" className={s.home_container}>
      <div className={s.content}>

        {/* "Neden Biz?" Kısmı */}
        <div style={{ background: "transparent"  }} className={s.card}>
           <h1 className={s.title}>Neden Biz?</h1>
          <p className={s.description}>
            24 yılı aşkın sektör tecrübemizle Havacılık ve Savunma Sanayii’ne özel danışmanlık hizmetleri sunuyoruz. Kalite yönetimi, tedarikçi geliştirme ve operasyonel mükemmellik alanında işletmelerin rekabet gücünü artırıyoruz.
          </p>
        </div>

        {/* Kart 01 */}
        <div className={s.card}>
          <span className={s.number}>01</span>
          <h1 className={s.title}>Uzmanlık ve Deneyim</h1>
          <p className={s.description}>
            24 yılı aşkın deneyimle kalite yönetimi ve tedarikçi geliştirme süreçlerini optimize ederek sektörde fark yaratıyoruz.
          </p>
        </div>

        {/* Kart 02 */}
        <div className={s.card}>
          <span className={s.number}>02</span>
          <h1 className={s.title}>Kalite Yönetimi</h1>
          <p className={s.description}>
            AS9100 ve diğer kalite standartlarına uygun dokümantasyon ve süreç yönetimi desteği sunarak işletmelerin uluslararası standartlara uyumunu sağlıyoruz.
          </p>
        </div>

        {/* Kart 03 */}
        <div className={s.card}>
          <span className={s.number}>03</span>
          <h1 className={s.title}>Tedarikçi Geliştirme</h1>
          <p className={s.description}>
            Küresel tedarik zincirlerinde performans artırımı ve sürdürülebilirlik sağlamak için tedarikçi geliştirme programları yürütüyoruz.
          </p>
        </div>

        {/* Kart 04 */}
        <div className={s.card}>
          <span className={s.number}>04</span>
          <h1 className={s.title}>Operasyonel Mükemmellik</h1>
          <p className={s.description}>
            6 Sigma projeleri ve süreç iyileştirme çalışmalarıyla şirketlerin operasyonel verimliliğini artırıyoruz.
          </p>
        </div>

        {/* Kart 05 */}
        <div className={s.card}>
          <span className={s.number}>05</span>
          <h1 className={s.title}>Güvenilir İş Ortaklığı</h1>
          <p className={s.description}>
            Şeffaflık, güvenilirlik ve uzmanlık temelinde sürdürülebilir iş birlikleri kurarak müşterilerimizin başarılarına katkı sağlıyoruz.
          </p>
        </div>

      </div>
    </div>
  );
};

export default ChooseUs;
